import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
} from "api";
import { IPaginatedResponse } from "models";
import { ICreatePlace, IPlace } from "models/place";

export const placesApi = (search: string, page: number, perPage: number) => {
  return authorizeGetRequest<IPaginatedResponse<IPlace>>(
    `places?search=${search}&page=${page}&per_page=${perPage}`
  );
};

export const placeSearchApi = (search: string, internalOnly: boolean = false) => {
  const params = new URLSearchParams({ search });
  if (internalOnly) {
    params.append('internal_only', 'true');
  }
  return authorizeGetRequest<IPaginatedResponse<IPlace>>(
    `places/search?${params.toString()}`
  );
};
export const createPlaceApi = (data: ICreatePlace) => {
  data.latitude = Number(data.latitude) as any;
  data.longitude = Number(data.longitude) as any;
  return authorizePostRequest<IPaginatedResponse<IPlace>>(`places`, data);
};

export const updatePlaceApi = (id: string, data: ICreatePlace) => {
  data.latitude = Number(data.latitude) as any;
  data.longitude = Number(data.longitude) as any;
  return authorizePatchRequest<IPaginatedResponse<IPlace>>(
    `places/${id}`,
    data
  );
};

export const deletePlaceApi = (id: string) => {
  return authorizeDeleteRequest<IPaginatedResponse<IPlace>>(`places/${id}`);
};
